export default function SeparatorRow({ onClickAdd }) {
  return (
  <div className='separator-row'>
    <div className="separator-line" />
    <div className="add-row" role="button" onClick={onClickAdd}>+</div>
  </div>
  );
}
